/* hs-eslint ignored failing-rules */
/* eslint-disable react/no-unused-prop-types */

'use es6';

import { memo } from 'react';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import Separator from '../../atoms/Separator';
import PrimaryMessageHeaderContent from '../../primary-message/components/PrimaryMessageHeaderContent';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackSubmissionHeader = /*#__PURE__*/memo(({
  message
}) => {
  const timestamp = getTimestamp(message);
  const timestampString = getHistoryFormattedTimestamp(timestamp);
  return /*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.responder.feedbackSubmission"
        })
      }), timestampString && /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(Separator, {}), timestampString]
      })]
    })
  });
});
FeedbackSubmissionHeader.displayName = 'FeedbackSubmissionHeader';
FeedbackSubmissionHeader.propTypes = {
  message: RecordPropType('FeedbackSubmissionMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default FeedbackSubmissionHeader;